import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationSummaryComponent } from 'components/common/validation-summary/validation-summary.component';
// import { CustomFormsModule } from 'ng2-validation'
import { ValidatorHelper } from 'components/custom-validators/validators.helper';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModelService } from 'services/model.service';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { RoleService } from 'services/role.service';
import { UserProfileSettingService } from 'api-services/user-profile-setting.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClientModule } from '@angular/common/http';
import { TextMaskModule } from 'angular2-text-mask';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EllipsifyMeDirective } from './elipsis.directive';
import { ErrorComponent } from 'components/shared-component/error/error.component';
import { AddContactComponent } from 'components/shared-component/add-contact/add-contact.component';
import { ComingSoonModalComponent } from 'components/shared-component/coming-soon-modal/coming-soon-modal.component';
import { AlertDialogComponent } from 'components/shared-component/alert-dialog/alert-dialog.component';
import { NoDataFoundComponent } from 'components/shared-component/no-data-found/no-data-found.component';
import { SearchFilterPipe } from './search-filter.pipe';
import { NgxMaskModule } from 'ngx-mask';
import { AutoFocusDirective } from './auto-focus.directive';
import { DatepickerModule } from 'ng2-datepicker';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { AttachmentsComponent } from 'components/shared-component/attachments/attachments.component';
import { UploadAttachmentModalComponent } from 'components/shared-component/attachments/upload-attachment-modal/upload-attachment-modal.component';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { AddAdminWithoutNPNComponent } from 'components/shared-component/add-contact/add-admin-without-npn/add-admin-without-npn.component';
import { DateRangePickerComponent } from 'components/shared-component/date-range-picker/date-range-picker.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { PreventCopyDirective } from './prevent-cut-copy-paste';
import { InitialsPipe } from './initials.pipe';
import { CustomTagDropdownComponent } from 'components/shared-component/custom-tag-dropdown/custom-tag-dropdown.component';
import { PhoneformatPipe } from './phoneformat.pipe';
import { CustomCheckboxDropdownComponent } from 'components/shared-component/custom-checkbox-dropdown/custom-checkbox-dropdown.component';
import { RemindersComponent } from 'components/shared-component/reminders/reminders.component';
import { SetRemindersComponent } from 'components/shared-component/reminders/set-reminders/set-reminders.component';
import { NewManualAppointmentComponent } from 'components/after-login/contacts/new-manual-appointment/new-manual-appointment.component';
import { AngularDraggableModule } from 'angular2-draggable';
import { NewManualLicenseComponent } from 'components/after-login/contacts/new-manual-license/new-manual-license.component';
import { AddManualLicenseFinraComponent } from 'components/after-login/contacts/add-manual-license-finra/add-manual-license-finra.component';
import { ThousandSeparatorDirective } from './thousand-separator.directive';
import { UsdMoneyPipe } from './usd-money.pipe';
import { NgxEditorModule } from 'ngx-editor';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { TrimInputWhiteSpaceDirective } from './trim-input-white-space.directive';
import { CeHoursDirective } from './ce-hours.directive';
import { ContactErrorOmissionsBondsComponent } from 'components/after-login/contact-dashboard/contact-error-omissions-bonds/contact-error-omissions-bonds.component';
import { AddAppointerPopupComponent } from 'components/shared-component/add-appointer-popup/add-appointer-popup.component';
import { AddAppointerInformationComponent } from 'components/shared-component/add-appointer-popup/add-appointer-information/add-appointer-information.component';
import { AppointerInformationComponent } from 'components/shared-component/appointer-information/appointer-information.component';
import { RequestStatusPopupComponent } from 'components/shared-component/request-status-popup/request-status-popup.component';
import { RecentActivityComponent } from 'components/after-login/onboarding/onboarding-dashboard/recent-activity/recent-activity.component';
import { CustomCheckboxDropdownCommonComponent } from 'components/shared-component/custom-checkbox-dropdown-common/custom-checkbox-dropdown-common.component';
import { SortByReferencePipe } from './sort-by-reference.pipe';
import { ActivityLogComponent } from '../components/after-login/dashboard/activity-log/activity-log.component';
import { AuditLogComponent } from '../components/after-login/contact-dashboard/audit-log/audit-log.component';
import { ContactAssociatedTaskComponent } from 'components/after-login/contact-dashboard/contact-associated-task/contact-associated-task.component';
import { BannerNotificationComponent } from 'components/shared-component/banner-notification/banner-notification.component';
import { CommonSidepanelAcitivityComponent } from 'components/shared-component/common-sidepanel-acitivity/common-sidepanel-acitivity.component';
import { SidepanelNotesComponent } from 'components/shared-component/common-sidepanel-acitivity/sidepanel-notes/sidepanel-notes.component';
import { SidepanelAttachmentsComponent } from 'components/shared-component/common-sidepanel-acitivity/sidepanel-attachments/sidepanel-attachments.component';

import { FilterByValuePipe } from './filterByValue.pipe';
import { SignaturePopupComponent } from 'components/shared-component/signature-popup/signature-popup.component';
import { SidepanelActivityErrorOmissionsComponent } from 'components/after-login/error-omissions/sidepanel-activity-error-omissions/sidepanel-activity-error-omissions.component';
import { SideNotesErrorOmissionsComponent } from 'components/after-login/error-omissions/sidepanel-activity-error-omissions/side-notes-error-omissions/side-notes-error-omissions.component';
import { SideAttachmentsErrorOmissionsComponent } from 'components/after-login/error-omissions/sidepanel-activity-error-omissions/side-attachments-error-omissions/side-attachments-error-omissions.component';
import { OnboardingNotesComponent } from 'components/after-login/onboarding/onboarding-dashboard/onboarding-notes/onboarding-notes.component';
import { AddCustomFieldsComponent } from 'components/shared-component/add-custom-fields/add-custom-fields.component';
import { ManageCustomFieldsComponent } from 'components/shared-component/manage-custom-fields/manage-custom-fields.component';
import { TitleCasePipe } from './titleCase.pipe';
import { CustomFieldInformationComponent } from 'components/shared-component/custom-field-information/custom-field-information.component';

const CommonModules = [
  CommonModule,
  ReactiveFormsModule,
  // CustomFormsModule,
  NgSelectModule,
  NgbModule,
  HttpClientModule,
  TextMaskModule,
  FormsModule,
  NgSelectModule,
  DatepickerModule,
  RecaptchaModule,
  RecaptchaFormsModule,
  VirtualScrollerModule,
  DragDropModule,
  AngularDraggableModule,
  NgxEditorModule
]

const CommonComponents = [
  ErrorComponent, 
  ValidationSummaryComponent, 
  AddContactComponent,
  ComingSoonModalComponent,
  AlertDialogComponent,
  NoDataFoundComponent,
  UsdMoneyPipe,
  SearchFilterPipe,
  HtmlToPlaintextPipe,
  EllipsifyMeDirective,
  TrimInputWhiteSpaceDirective,
  AutoFocusDirective,
  ThousandSeparatorDirective,
  AttachmentsComponent,
  UploadAttachmentModalComponent,
  AddAdminWithoutNPNComponent,
  DateRangePickerComponent,
  PreventCopyDirective,
  InitialsPipe,
  CustomTagDropdownComponent,
  PhoneformatPipe,
  CustomCheckboxDropdownComponent,
  CustomCheckboxDropdownCommonComponent,
  RemindersComponent,
  SetRemindersComponent,
  NewManualAppointmentComponent,
  NewManualLicenseComponent,
  AddManualLicenseFinraComponent,
  CeHoursDirective,
  ContactErrorOmissionsBondsComponent,
  AddAppointerPopupComponent,
  AddAppointerInformationComponent,
  AppointerInformationComponent,
  RequestStatusPopupComponent,
  RecentActivityComponent,
  SortByReferencePipe,
  ActivityLogComponent,
  AuditLogComponent,
  BannerNotificationComponent,
  CommonSidepanelAcitivityComponent,
  SidepanelNotesComponent,
  SidepanelAttachmentsComponent,
  FilterByValuePipe,
  ContactAssociatedTaskComponent,
  SignaturePopupComponent,
  SidepanelActivityErrorOmissionsComponent,
  SideNotesErrorOmissionsComponent,
  SideAttachmentsErrorOmissionsComponent,
  OnboardingNotesComponent,
  AddCustomFieldsComponent,
  ManageCustomFieldsComponent,
  TitleCasePipe,
  CustomFieldInformationComponent
]

@NgModule({
  declarations: [...CommonComponents, TrimInputWhiteSpaceDirective],
  imports: [
    ...CommonModules, 
    MalihuScrollbarModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaskModule.forRoot()
  ],
  exports:[
    ...CommonModules, 
    MalihuScrollbarModule,
    NgMultiSelectDropDownModule,
    NgxMaskModule,
    ...CommonComponents
  ],

  providers:[ValidatorHelper,ModelService,RoleService,UserProfileSettingService]
})
export class SharedModule { }
